$(document).ready(function () {
  // KITGK - limiting cart item quantity - 28 Dec '23
  let originalButtonText = $(".single-product-addtocart button").html();
  //event listener for qunatity change (disables add to cart button)
  $('input[name="quantity"]').change((e) => {
    $(".productMessage").html("");
    fetch(window.Shopify.routes.root + "cart.js")
      .then((response) => response.json())
      .then((data) => {
        let items = data.items;
        let currentSku = $("*[itemprop=sku]").attr("content");
        let valid = true;
        let max = 100;

        //check if selected quantity won't exceed limit in cart
        $(items).each((index, item) => {
          if (item.sku == currentSku) {
            max = 100 - item.quantity;
            if (
              item.quantity + parseInt($('input[name="quantity"]').val()) >
              100
            ) {
              valid = false;
            }
          }
        });
        //show add to cart / limit in button
        if (valid && parseInt($('input[name="quantity"]').val()) <= max) {
          $(".single-product-addtocart button").html(originalButtonText);
          if (
            $(".single-product-addtocart button").hasClass("limitQuantityBtn")
          ) {
            $(".single-product-addtocart button").removeClass(
              "limitQuantityBtn"
            );
          }
        }
        // HC - Disable limit of 100 products - 6 Jun 2024
        // else{
        //   $(".single-product-addtocart button").html("Limit 100 Per Order")
        //   if(!$(".single-product-addtocart button").hasClass("limitQuantityBtn")){
        //       $(".single-product-addtocart button").addClass("limitQuantityBtn");
        //   }
        //   $("#AddToCart").prop('disabled', false)
        // }
      });
  });

  $(".quantity input").keyup((e) => {
    $('input[name="quantity"]').trigger("change");
  });
  /* End Qty ITG */

  $(".child").hide();
  $(".sidebar-nav-toggle").click(function () {
    var myparent = $(this).parent();
    $(".child", myparent).each(function () {
      $(this).toggle();
    });
  });

  $(".cust-toggle").click(function () {
    var $this = $(this);
    if ($this.hasClass("open-menu-drop")) {
      $(this).next().removeClass("is-open");
      $(this).removeClass("open-menu-drop");
      $this.next().slideUp("slow");
    } else {
      $(this).addClass("open-menu-drop");
      $this.next().slideDown("slow");
      $this.next().addClass("is-open");
    }
  });

  //if the link goes off of rangerink, it will open a new tab anywhere on the site
  var links = document.links;
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = "_blank";
    }
  }

  $(".scrollSelect").on("change", function () {
    // Make sure this.hash has a value before overriding default behavior
    if ($(this).val() !== "") {
      // Store hash
      var hash = $(this).val();

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $("html, body").animate(
        {
          scrollTop: $(hash).offset().top,
        },
        800,
        function () {}
      );
    } // End if
  });

  /*  let originalButtonText = $(".single-product-addtocart button").html()
  //event listener for qunatity change (disables add to cart button)
  $("#Quantity").change((e)=>{
    $(".productMessage").html("")
    fetch(window.Shopify.routes.root + 'cart.js').then((response) => response.json()).then((data) => {
        let items = data.items;
    	let currentSku = $("*[itemprop=sku]").attr("content")
        let valid = true;
        let max = 100;
      
        //check if selected quantity won't exceed limit in cart
        $(items).each((index,item)=>{
    		if(item.sku == currentSku ){
              max = 100 - item.quantity;
              if(item.quantity + parseInt($("#Quantity").val()) > 100){
                valid = false;
              }
    		}
        })
        //show add to cart / limit in button
        if(valid &&  parseInt($("#Quantity").val()) <= max){
            $(".single-product-addtocart button").html(originalButtonText)
            if($(".single-product-addtocart button").hasClass("limitQuantityBtn")){
              $(".single-product-addtocart button").removeClass("limitQuantityBtn");
            }
        }else{
          $(".single-product-addtocart button").html("Limit 100 Per Order")
          if(!$(".single-product-addtocart button").hasClass("limitQuantityBtn")){
              $(".single-product-addtocart button").addClass("limitQuantityBtn");
          }
          $("#AddToCart").prop('disabled', false)
        }
    })
})*/

  //	Featured Product Carousel
  $(".featured-product").owlCarousel({
    loop: true,
    margin: 20,
    responsiveClass: true,
    navText: [
      '<button class="flickity-button flickity-prev-next-button previous" type="button" aria-label="Previous"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M36.7,76.9c1.9,1.4,1.9,3.8,0,5.7c-0.6,0.6-1.6,0.9-2.8,0.9c-0.9,0-1.9-0.3-2.8-0.9L2.2,52.8 c-1.9-1.4-1.9-4.3,0-5.7L30,18.3c1.4-1.4,3.8-1.4,5.2,0c1.9,1.4,1.9,4.3,0,5.7L10.2,50L36.7,76.9z M95.2,46.2c1.9,0,3.8,1.9,3.8,4.3 c0,2.4-1.9,3.8-3.8,3.8H13c-2.4,0-3.8-1.4-3.8-3.8c0-2.4,1.4-4.3,3.8-4.3H95.2z" class="arrow"></path></svg></button>',
      '<button class="flickity-button flickity-prev-next-button next" type="button" aria-label="Next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M36.7,76.9c1.9,1.4,1.9,3.8,0,5.7c-0.6,0.6-1.6,0.9-2.8,0.9c-0.9,0-1.9-0.3-2.8-0.9L2.2,52.8 c-1.9-1.4-1.9-4.3,0-5.7L30,18.3c1.4-1.4,3.8-1.4,5.2,0c1.9,1.4,1.9,4.3,0,5.7L10.2,50L36.7,76.9z M95.2,46.2c1.9,0,3.8,1.9,3.8,4.3 c0,2.4-1.9,3.8-3.8,3.8H13c-2.4,0-3.8-1.4-3.8-3.8c0-2.4,1.4-4.3,3.8-4.3H95.2z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
    ],
    nav: true,
    dots: false,
    responsive: {
      0: {
        items: 1,
      },
      481: {
        items: 2,
      },
      769: {
        items: 3,
      },
      992: {
        items: 5,
      },
    },
  });

  window.addEventListener("DOMContentLoaded", function () {
    const $form = $('form[action="/cart/add"]');
    $form.on("submit", function (evt) {
      evt.preventDefault();
      $(".Sd_addProduct").prop("disabled", true);
      const formData = $(this).serialize();
      $.ajax({
        url: "/cart/add.js",
        data: formData,
        dataType: "json",
        method: "post",
        success: function (response) {
          $(".Sd_addProduct").prop("disabled", false);
          //$(".productMessage").html("Max Available Quantity: "+$("#Quantity").data("max"))
          ajaxCart.load();
        },
        error: function (response) {
          alert(response.responseJSON["description"]);
        },
      });
    });
  });

  // collection filter js start
  $(".collection-sorting-brand").click(function () {
    $(".brand-by").toggleClass("open");
    $(".designer-by").removeClass("open");
    $(".filter-by").removeClass("open");
    $(".sorting-brand-arrow").toggleClass("arrow-reverse");
    $(".sorting-designer-arrow").removeClass("arrow-reverse");
    $(".filter-brand-arrow").removeClass("arrow-reverse");
  });

  $(".collection-sorting-designer").click(function () {
    $(".designer-by").toggleClass("open");
    $(".brand-by").removeClass("open");
    $(".filter-by").removeClass("open");
    $(".sorting-designer-arrow").toggleClass("arrow-reverse");
    $(".sorting-brand-arrow").removeClass("arrow-reverse");
    $(".filter-brand-arrow").removeClass("arrow-reverse");
  });

  $(".collection-sorting-filter").click(function () {
    $(".filter-by").toggleClass("open");
    $(".designer-by").removeClass("open");
    $(".brand-by").removeClass("open");
    // $('.filter-brand-arrow').toggleClass('arrow-reverse');
    $(".sorting-designer-arrow").removeClass("arrow-reverse");
    $(".sorting-brand-arrow").removeClass("arrow-reverse");
    // SGA - Use font awesome icons instead
    $(this).find("svg").toggleClass("filter-open");
  });

  //Project tab menu
  $("ul.project-tabs li").click(function () {
    var tab_id = $(this).attr("data-tab");

    $("ul.project-tabs li").removeClass("current");
    $(".project-tab-content").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
  });

  // bind change event to select
  // $('.redirectSelect').on('change', function () {
  //   var url = $(this).val(); // get selected value
  //   if (url) { // require a URL
  //     window.response = url; // redirect
  //   }
  //   return false;
  // });

  $(".redirectSelect").on("change", function () {
    // set the window's location property to the value of the option the user has selected
    window.location = $(this).val();
  });

  $(".readmore").click(function (event) {
    event.preventDefault();
    var descriptionFull = document.querySelector(
      ".collection-description-full-showLess"
    );
    descriptionFull.style.display = "block";
    var descriptionShort = document.querySelector(
      ".collection-description-short-showMore"
    );
    descriptionShort.style.display = "none";
  });
  $(".readless").click(function (event) {
    event.preventDefault();
    var descriptionFull = document.querySelector(
      ".collection-description-full-showLess"
    );
    descriptionFull.style.display = "none";
    var descriptionShort = document.querySelector(
      ".collection-description-short-showMore"
    );
    descriptionShort.style.display = "block";
  });

  $(".mob_readmore").click(function (event) {
    event.preventDefault();
    var descriptionFull = document.querySelector(
      ".mob_collection-description-full-showLess"
    );
    descriptionFull.style.display = "block";
    var descriptionShort = document.querySelector(
      ".mob_collection-description-short-showMore"
    );
    descriptionShort.style.display = "none";
  });
  $(".mob_readless").click(function (event) {
    event.preventDefault();
    var descriptionFull = document.querySelector(
      ".mob_collection-description-full-showLess"
    );
    descriptionFull.style.display = "none";
    var descriptionShort = document.querySelector(
      ".mob_collection-description-short-showMore"
    );
    descriptionShort.style.display = "block";
  });

  // Accordion Faq page
  var acc = document.getElementsByClassName("accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].onclick = function () {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.display === "block") {
        panel.style.display = "none";
      } else {
        panel.style.display = "block";
      }
    };
  }

  $("h5.hc-side-box-title").on("click", function () {
    $(this).parent().find(".hc-side-box-list").slideToggle();
  });

  $(".tab-review").on("click", function () {
    var getreview = $(document)
      .find(".review_tab")
      .html('<div id="looxReviews"></div>');
    //console.log(getreview);
    $(document).find("#yv-review").append(getreview);
  });

  $(".custom-mobile_sub_menu .select_menu").on("click", function () {
    $(this).parents(".custom-mobile_sub_menu").find("nav").toggle();
  });

  $(".custom-mobile_sub_menu .site-nav--has-dropdown a").on(
    "click",
    function () {
      $(this).parents(".site-nav--has-dropdown").find("ul").toggle();
      // $(this).parents('.site-nav--has-dropdown').find('.site-nav__dropdown ').css('position', 'initial');
      // $(this).parents('.site-nav--has-dropdown').find('.site-nav__dropdown ').css('pointer-events', 'auto');
    }
  );

  $("ul.tabs").each(function () {
    var active,
      content,
      links = $(this).find("span");
    active = links.first().addClass("active");
    content = $(active.attr("href"));
    links.not(":first").each(function () {
      $($(this).attr("href")).hide();
    });
    $(this)
      .find("span")
      .click(function (e) {
        e.preventDefault();
        active.removeClass("active");
        content.hide();
        active = $(this);
        content = $($(this).attr("href"));
        active.addClass("active");
        content.show();
        return false;
      });
  });

  $(".press-search").on("keyup", function () {
    var searchString = $(this).val();
    $(document)
      .find(".press-wraper")
      .each(function (index, value) {
        //console.log($(this).text());
        var currentName = $(value).text();
        if (
          currentName.toUpperCase().indexOf(searchString.toUpperCase()) > -1
        ) {
          $(value).show();
        } else {
          $(value).hide();
        }
      });
  });

  $(".product-button.pro-readmore").click(function (e) {
    e.preventDefault();
    $(".pro-short-description").css({ display: "none" });
    $(".pro-full-description").css({ display: "block" });
  });
  $(".product-button.pro-readless").click(function (e) {
    e.preventDefault();
    $(".pro-full-description").css({ display: "none" });
    $(".pro-short-description").css({ display: "block" });
  });

  //  $.ajax({
  //   url: "http://ipinfo.io",
  //   type: 'GET',
  //   dataType: 'json',
  //   success: function(response) {
  //     if($('.is_blocked')) {
  //       if(response.country_code === 'US') {
  //         if(response.region_name === 'AK' || response.region_name === 'Alaska' ||
  //            response.region_name === 'HI' || response.region_name === 'Hawaii') {
  //           $('.is_blocked').each(function() {
  //             $(this).find('.AddToCartText').text('LOWER 48 STATES ONLY');
  //             $(this).find('.product-quick-add').text('LOWER 48 STATES ONLY');
  //             $(this).find('.Sd_addProduct').addClass('blocked_for_region');
  //             $(this).addClass('blocked_for_region');
  //           });
  //         }
  //       }
  //       if(response.country_code === 'PR') {
  //         $('.is_blocked').each(function() {
  //           $(this).find('.AddToCartText').text('LOWER 48 STATES ONLY');
  //           $(this).find('.product-quick-add').text('LOWER 48 STATES ONLY');
  //           $(this).addClass('blocked_for_region');
  //         });
  //       }
  //     }
  //   }
  // });
});

/* HC - Updating changes for subcollection slider - 20 Jul '22 */

$(function () {
  $(".subcollection-carousel").owlCarousel({
    loop: true,
    margin: 20,
    responsiveClass: true,
    nav: false,
    navText: [
      "<div class='nav-btn prev-slide'></div>",
      "<div class='nav-btn next-slide'></div>",
    ],
    items: 2,
    dots: true,
  });
});

// $(function(){
//   if($(window).width() < 769)
//     {
//       $('.hc-subcollection').owlCarousel({
//         loop: true,
//         margin: 20,
//         responsiveClass: true,
//         nav: true,
//         navText:["<div class='nav-btn prev-slide'></div>","<div class='nav-btn next-slide'></div>"],
//         dots: false,
//         responsive: {
//           0: {
//             items: 2
//           },
//           481: {
//             items: 3
//           },
//           769: {
//             items: 4
//           }
//         }
//       });
//     }
//   $(window).resize(function(){
//     if($(window).width() < 769)
//     {
//       $('.hc-subcollection').owlCarousel({
//         loop: true,
//         margin: 20,
//         responsiveClass: true,
//         nav: true,
//         navText:["<div class='nav-btn prev-slide'></div>","<div class='nav-btn next-slide'></div>"],
//         dots: false,
//         responsive: {
//           0: {
//             items: 2,
//             dots: true,
//           },
//           481: {
//             items: 3,
//             dots: true,
//           },
//           769: {
//             items: 4
//           }
//         }
//       });
//     }
//   });

// $('.hc-subcollection').owlCarousel({
//      loop: true,
//      margin: 20,
//      responsiveClass: true,
//      nav: true,
//      navText:["<div class='nav-btn prev-slide'></div>","<div class='nav-btn next-slide'></div>"],
//      dots: false,
//      responsive: {
//        0: {
//          items: 2,
//          dots: true,
//        },
//        481: {
//          items: 3,
//          dots: true,
//        },
//        769: {
//          items: 4
//        }
//      }
//    });
//});

var checkboxes = document.querySelectorAll("[hidden-data]");
var hiddenfield = document.getElementById("filter__by");
var selectedTags = [];

// Gets checked boxes and adds to selectedTags array
function getChecked() {
  checkboxes.forEach(function (box) {
    box.checked && selectedTags.indexOf(box.value) == -1
      ? selectedTags.push(box.value)
      : null;
  });
}

// Called when checkbox is selected and addes to selectedTags array
function fillHidden() {
  var hasTag = selectedTags.indexOf(this.value);

  if (hasTag == -1) {
    selectedTags.push(this.value);
  } else {
    selectedTags.splice(hasTag, 1);
  }

  hiddenfield.value = selectedTags.join("+");
}

// Calls getChecked function
getChecked();
// Adds event listener to all checkboxes
checkboxes.forEach(function (checkbox) {
  checkbox.addEventListener("change", fillHidden);
});

$(".filter-by-button").on("click", function () {
  var filter_string = $("#filter__by").val();
  var url = $(document).find(".rangerink-home").data("url");
  //console.log(filter_string);
  var new_url = url + filter_string;
  //console.log(new_url)
  window.location.href = new_url;
});

/* SGA youtube lazylaod */
(function () {
  var youtube = document.querySelectorAll(".yt-lazyload");

  for (var i = 0; i < youtube.length; i++) {
    youtube[i].addEventListener("click", function () {
      var iframe = document.createElement("iframe");
      iframe.setAttribute("width", "400");
      iframe.setAttribute("height", "320");
      iframe.setAttribute("frameborder", "0");
      iframe.setAttribute("allowfullscreen", "");
      iframe.setAttribute(
        "src",
        "https://www.youtube.com/embed/" +
          this.dataset.embed +
          "?rel=0&showinfo=0&autoplay=1&mute=1"
      );

      this.innerHTML = "";
      this.appendChild(iframe);
    });
  }
});

/* HC - Updating changes to Reward page login - 27 Sept '22 */
$(document).ready(function () {
  setTimeout(function () {
    var url_array = window.location.href.split("/");
    var length_array = url_array.length;
    if (url_array[length_array - 1] != "login") {
      var logi_uri = "/account/login?checkout_url=" + window.location.href;
      $(".lion-action-button--neutral").attr("href", logi_uri);
    }
  }, 1500);

  // $('a[href^="#"]').on('click',function () {
  //  //e.preventDefault();
  //  var target = this.hash;
  //  var $target = $(target);
  //  $('html, body').animate({
  //      'scrollTop': $target.offset().top-100
  //  }, 50);
  //      return false;
  //     //    , function () {
  //  //     //window.location.hash = target;
  //  // });
  //  });

  var checkboxes = document.querySelectorAll("[hidden-data]");
  var hiddenfield = document.getElementById("filterblog__by");
  var selectedTags = [];

  // Gets checked boxes and adds to selectedTags array
  function getChecked() {
    checkboxes.forEach(function (box) {
      box.checked && selectedTags.indexOf(box.value) == -1
        ? selectedTags.push(box.value)
        : null;
    });
  }

  // Called when checkbox is selected and addes to selectedTags array
  function fillHidden() {
    var hasTag = selectedTags.indexOf(this.value);

    if (hasTag == -1) {
      selectedTags.push(this.value);
    } else {
      selectedTags.splice(hasTag, 1);
    }

    hiddenfield.value = selectedTags.join("+");
  }

  // Calls getChecked function
  getChecked();

  // Adds event listener to all checkboxes
  checkboxes.forEach(function (checkbox) {
    checkbox.addEventListener("change", fillHidden);
  });

  $(".filterblog-by-button").on("click", function () {
    var filter_string = $("#filterblog__by").val();
    var url = $(document).find(".rangerink-home").data("geturl");
    console.log(filter_string);
    var new_url = url + filter_string;
    //console.log(new_url)
    window.location.href = new_url;
  });
});
